import React from 'react';
import { useTranslation } from 'react-i18next';
import './PageLoading.css';

export default function PageLoading() {
  const { t } = useTranslation();
  return <div className="page-loading" role="status">{t('common.loading')}</div>;
}
